import {NgModule} from "@angular/core";
import {TimeZoneSingleSelectEditControlComponent} from "./controls/time-zone-single-select-edit-control.component";
import {SharedModule} from "../shared/shared.module";
import {FrameworkModule} from "../framework/framework.module";
import {DayOfWeekSingleSelectColumnComponent} from "./controls/day-of-week-single-select-column.component";
import {DayOfWeekMultiSelectSearchControlComponent} from "./controls/day-of-week-multi-select-search-control.component";
import {DateRangeSingleSelectSearchControlComponent} from "./controls/date-range-single-select-search-control.component";
import {HourOfDayMultiSelectSearchControlComponent} from "./controls/hour-of-day-multi-select-search-control.component";
import {MonthOfYearMultiSelectSearchControlComponent} from "./controls/month-of-year-multi-select-search-control.component";
import {DateMultiSelectSearchControlComponent} from "./controls/date-multi-select-search-control.component";
import {WeekOfYearMultiSelectSearchControlComponent} from "./controls/week-of-year-multi-select-search-control.component";
import {YearMultiSelectSearchControlComponent} from "./controls/year-multi-select-search-control.component";
import {YearMonthMultiSelectSearchControlComponent} from "./controls/year-month-multi-select-search-control.component";
import {HourQuarterMultiSelectSearchControlComponent} from "./controls/hour-quarter-multi-select-search-control.component";
import {YearCalendarQuarterMultiSelectSearchControlComponent} from "./controls/year-calendar-quarter-multi-select-search-control.component";
import {CalendarQuarterOfYearMultiSelectSearchControlComponent} from "./controls/calendar-quarter-of-year-multi-select-search-control.component";
import {DayOfWeekSingleSelectEditControl} from "./controls/day-of-week-single-select-edit-control.component";
import {DayOfWeekMultiSelectEditControl} from "./controls/day-of-week-multi-select-edit-control.component";
import {MonthOfYearMultiSelectEditControlComponent} from "./controls/month-of-year-multi-select-edit-control.component";
import {DayOfMonthSingleSelectEditControlComponent} from "./controls/day-of-month-single-select-edit-control.component";
import {TimeZoneMultiSelectEditControlComponent} from "./controls/time-zone-multi-select-edit-control.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule
    ],
    declarations: [
        TimeZoneSingleSelectEditControlComponent,
        TimeZoneMultiSelectEditControlComponent,
        DayOfMonthSingleSelectEditControlComponent,
        DayOfWeekSingleSelectColumnComponent,
        DayOfWeekMultiSelectSearchControlComponent,
        DayOfWeekSingleSelectEditControl,
        DateRangeSingleSelectSearchControlComponent,
        HourOfDayMultiSelectSearchControlComponent,
        HourQuarterMultiSelectSearchControlComponent,
        MonthOfYearMultiSelectSearchControlComponent,
        MonthOfYearMultiSelectEditControlComponent,
        CalendarQuarterOfYearMultiSelectSearchControlComponent,
        DateMultiSelectSearchControlComponent,
        WeekOfYearMultiSelectSearchControlComponent,
        YearMultiSelectSearchControlComponent,
        YearMonthMultiSelectSearchControlComponent,
        YearCalendarQuarterMultiSelectSearchControlComponent,
        DayOfWeekMultiSelectEditControl
    ],
    exports: [
        TimeZoneSingleSelectEditControlComponent,
        TimeZoneMultiSelectEditControlComponent,
        DayOfMonthSingleSelectEditControlComponent,
        DayOfWeekSingleSelectColumnComponent,
        DayOfWeekMultiSelectSearchControlComponent,
        DayOfWeekSingleSelectEditControl,
        DateRangeSingleSelectSearchControlComponent,
        HourOfDayMultiSelectSearchControlComponent,
        HourQuarterMultiSelectSearchControlComponent,
        MonthOfYearMultiSelectSearchControlComponent,
        MonthOfYearMultiSelectEditControlComponent,
        CalendarQuarterOfYearMultiSelectSearchControlComponent,
        DateMultiSelectSearchControlComponent,
        WeekOfYearMultiSelectSearchControlComponent,
        YearMultiSelectSearchControlComponent,
        YearMonthMultiSelectSearchControlComponent,
        YearCalendarQuarterMultiSelectSearchControlComponent,
        DayOfWeekMultiSelectEditControl
    ]
})
export class DateTimeSharedModule {
}
